import Button from '@kurtosys/ksys-app-components/dist/components/base/Button';
import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';

export default InjectedStyledComponent(Button, 'searchBar', ['clearSearch']);